import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOnOutlined,
  HomeOutlined,
  StorageOutlined,
  DonutLargeOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetWarehouseDetailQuery } from "store/services/warehouseApi";

const WarehouseInfoScreen = ({ warehouseId }) => {
  const breadcrumbs = [
    {
      title: "Warehouse Info",
    },
  ];

  // RTK Query
  const {
    data: warehouseDetail,
    isLoading: loadingWarehouseDetail,
    error,
  } = useGetWarehouseDetailQuery(warehouseId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingWarehouseDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingWarehouseDetail ? (
          <Box padding={3}>
            <Typography variant="h6">{warehouseDetail?.name}</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HomeOutlined color="primary" />}
                  title="Name"
                  subtitle={warehouseDetail?.name}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Location"
                  subtitle={warehouseDetail?.location}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <StorageOutlined color="primary" />}
                  title="Capacity"
                  subtitle={warehouseDetail?.capacity}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DonutLargeOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={warehouseDetail?.status === "Active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehouseInfoScreen;
